import Base from '../../Base';
import styles from './TiktokPublish.module.scss';

const TiktokPublish = ({ campaign, activity, handle }) => {

  return (
    <Base title='TikTok'>
      <div className={styles.root}>
      </div>
    </Base>
  );
};

export default TiktokPublish;